module.exports = __webpack_public_path__ + "static/media/rhodes_0020_morrells.30277654.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0020_morrells.jpg
// module id = 175
// module chunks = 0